//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  Config
import {VocabButtons as btn_vocab} from '../../../../../ConfigFiles/multilingual/VocabButtons';
//  ----------      END   IMPORT  BLOCK       ----------

const HistorySortControls = ({ sortByDate, setSortByDate }) => {
    const { lan } = useLanguage();

    // Helper function to render the tooltip with text from the vocabulary
    const renderTooltip = (text) => (
        <Tooltip id={`sort-tooltip-${text}`}>{text}</Tooltip>
    );

    return (
        <div className="d-flex justify-content-between mb-2">
            {/* Ascending Sort Button */}
            <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip(btn_vocab.ascendent[lan])}
            >
                <Button 
                    variant={sortByDate === 'asc' ? 'primary' : 'outline-secondary'} 
                    size="sm"
                    onClick={() => setSortByDate('asc')}
                >
                    &uarr; {/* Visual indicator only */}
                </Button>
            </OverlayTrigger>

            {/* Descending Sort Button */}
            <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip(btn_vocab.descendent[lan])}
            >
                <Button 
                    variant={sortByDate === 'desc' ? 'primary' : 'outline-secondary'} 
                    size="sm"
                    onClick={() => setSortByDate('desc')}
                >
                    &darr; {/* Visual indicator only */}
                </Button>
            </OverlayTrigger>
        </div>
    );
};

export default HistorySortControls;